"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ic_Facebook__mono", {
  enumerable: true,
  get: function get() {
    return _ic_facebook__mono.default;
  }
});
Object.defineProperty(exports, "ic_Google__mono", {
  enumerable: true,
  get: function get() {
    return _ic_google__mono.default;
  }
});
Object.defineProperty(exports, "ic_Instagram__mono", {
  enumerable: true,
  get: function get() {
    return _ic_instagram__mono.default;
  }
});
Object.defineProperty(exports, "ic_Messengder__mono", {
  enumerable: true,
  get: function get() {
    return _ic_messengder__mono.default;
  }
});
Object.defineProperty(exports, "ic_Spotify__mono", {
  enumerable: true,
  get: function get() {
    return _ic_spotify__mono.default;
  }
});
Object.defineProperty(exports, "ic_Twitter__mono", {
  enumerable: true,
  get: function get() {
    return _ic_twitter__mono.default;
  }
});
Object.defineProperty(exports, "ic_Whatsapp__mono", {
  enumerable: true,
  get: function get() {
    return _ic_whatsapp__mono.default;
  }
});
Object.defineProperty(exports, "ic_Youtube__mono", {
  enumerable: true,
  get: function get() {
    return _ic_youtube__mono.default;
  }
});
Object.defineProperty(exports, "ic_iMessage__mono", {
  enumerable: true,
  get: function get() {
    return _ic_imessage__mono.default;
  }
});

var _ic_facebook__mono = _interopRequireDefault(require("./ic_facebook__mono"));

var _ic_google__mono = _interopRequireDefault(require("./ic_google__mono"));

var _ic_instagram__mono = _interopRequireDefault(require("./ic_instagram__mono"));

var _ic_messengder__mono = _interopRequireDefault(require("./ic_messengder__mono"));

var _ic_spotify__mono = _interopRequireDefault(require("./ic_spotify__mono"));

var _ic_twitter__mono = _interopRequireDefault(require("./ic_twitter__mono"));

var _ic_whatsapp__mono = _interopRequireDefault(require("./ic_whatsapp__mono"));

var _ic_youtube__mono = _interopRequireDefault(require("./ic_youtube__mono"));

var _ic_imessage__mono = _interopRequireDefault(require("./ic_imessage__mono"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }